import { Button, Text } from 'components';
import {
  AuthContext,
  LayoutContext,
  OnboardingPreLaunchModalContext,
} from 'contexts';
import React from 'react';
import { formatDateStrWithYearShort } from 'utils';
import { shiftToUtc } from '../../../onboarding/util';

const PreLaunchShowingInstructions = () => {
  const { onboarding } = React.useContext(AuthContext);
  const { isMobileView } = React.useContext(LayoutContext);
  const { openModal, totalCount, configuredCount } = React.useContext(
    OnboardingPreLaunchModalContext,
  );

  const renderCount = () => {
    if (!totalCount) return null;
    return (
      <Text>
        {' '}
        (
        <Text strong>
          {configuredCount}&nbsp;/&nbsp;{totalCount}
        </Text>
        &nbsp;completed)
      </Text>
    );
  };

  const renderDate = () => {
    if (!onboarding?.launchDate) return null;
    return (
      <>
        Your brokerage is launching on{' '}
        <Text strong>
          {formatDateStrWithYearShort(shiftToUtc(onboarding?.launchDate))}
        </Text>
        .
      </>
    );
  };

  return (
    <Text textAlign="center" block={false} nowrap={!isMobileView}>
      {renderDate()} Setup showing instructions on your listings!
      {renderCount()}
      <Button type="link" onClick={openModal} data-cy="view-details-button">
        View Details
      </Button>
    </Text>
  );
};

export default PreLaunchShowingInstructions;
